import type { Payment } from "@/model/payment";

interface Props {
  paymentType: string;
  payment: Payment;
}

export default function InitPaymentHeader({ paymentType, payment }: Props) {
  switch (paymentType) {
    case "blink":
      return (
        <div className="flex flex-col gap-1">
          {/* only show merchantName here because creditorName will always be `blink` as that is used as creditor name for Blink-type sales channels */}
          <span className="text-2xl">{payment?.merchantName}</span>
          <span className="text-md">{payment?.salesChannelLocation}</span>
          <span className="text-md">{payment?.blinkName}</span>
        </div>
      );
    case "pos":
      return (
        <div className="flex flex-col gap-1">
          <span className="text-2xl">{payment?.salesChannelName}</span>
          <span className="text-md">{payment?.salesChannelLocation}</span>
          <span className="text-md">{payment?.merchantName}</span>
        </div>
      );
    case "ecom":
      return (
        <div className="flex flex-col gap-1">
          <span className="text-2xl">{payment?.salesChannelName}</span>
          <span className="text-md">{payment?.salesChannelLocation}</span>
          <span className="text-md">{payment?.merchantName}</span>
        </div>
      );
    case "standalone":
      return (
        <div className="flex flex-col gap-1">
          <span className="text-2xl">{payment?.salesChannelName}</span>
          <span className="text-md">{payment?.salesChannelLocation}</span>
          <span className="text-md">{payment?.merchantName}</span>
        </div>
      );
    case "yom":
      return (
        <div className="flex flex-col gap-1">
          <span className="text-2xl">{payment?.creditorName}</span>
          <span className="text-md">
            {payment?.message}
          </span>
        </div>
      );
    case "p2p":
      return (
        <div className="flex flex-col gap-1">
          <span className="text-2xl">{payment?.creditorName}</span>
          <span className="text-md">
            {payment?.message}
          </span>
        </div>
      );
  }
}
